// extracted by mini-css-extract-plugin
module.exports = {"image":"Image-module__image___3RmPN","click":"Image-module__click___29TeE"};